__turbopack_context__.v({
  "component": "style-module-scss-module__CgoASq__component",
  "component-small": "style-module-scss-module__CgoASq__component-small",
  "cta-button": "style-module-scss-module__CgoASq__cta-button",
  "disclaimer": "style-module-scss-module__CgoASq__disclaimer",
});
